/**
 * Plain fetch against the LandHawk API. Previews post the whole lease form on every refresh, so they skip the
 * use-http provider, whose request interceptor copies each request body into localStorage.
 */
export function previewApiFetch(path: string, init: RequestInit = {}): Promise<Response> {
    const jwt = localStorage.getItem('jwt') || sessionStorage.getItem('jwt');
    const headers: { [name: string]: string } = { ...(init.headers as { [name: string]: string }), Authorization: `Bearer ${jwt}` };

    return fetch(`${process.env.REACT_APP_BASE_API_URL}/${path.replace(/^\//, '')}`, { ...init, headers });
}

/** The server's message for a failed request (controllers return plain-text errors), or a fallback. */
export async function previewErrorMessage(response: Response, fallback: string): Promise<string> {
    if (response.status === 401) {
        return 'Your LandHawk session has expired. Sign in again to refresh the preview.';
    }

    try {
        const text = (await response.text()).trim();
        return text.length > 0 && text.length < 500 && text.charAt(0) !== '<' ? text.replace(/^"|"$/g, '') : fallback;
    } catch {
        return fallback;
    }
}



// WEBPACK FOOTER //
// ./src/components/common/docxPreview/previewApi.ts